// agriflow/activities/static/js/module/activitiesCreate.js

import FetchHandler from '../../../../assets/js/assets/FetchHandler'
import AlertHandler from '../../../../assets/js/modules/alertHandler';

import { Modal } from 'bootstrap';
import Dropzone from 'dropzone';
import 'dropzone/dist/dropzone.css';


export default class ActivitiesCrate {
    constructor(formsUrl, buttonClass) {
        this.formsUrl = formsUrl;
        this.buttonClass = buttonClass;
        this.modalEl = document.querySelector('#activitiesModal');
        this.modal = new Modal(this.modalEl, { backdrop: 'static' });
        this.bindButtonEvents();
        this.addCloseEventListeners();
    }

    addCloseEventListeners() {
        document.querySelectorAll('.close-modal-button-activities').forEach(button => {
            button.addEventListener('click', () => {
                this.modal.hide()
            });
        });
    }

    async bindButtonEvents() {
        document.body.addEventListener('click', async (event) => {
            const btn = event.target.closest(this.buttonClass);
            if (!btn) return;
            try {
                const response = await FetchHandler.getData(btn.dataset.url, {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                });
                const data = await response.json();
                const { html } = data;
                this.modalEl.querySelector('.modal-body').innerHTML = ''
                this.modalEl.querySelector('.modal-body').innerHTML = html || '<p>Kein Inhalt verfügbar</p>';
                this.modal.show();

                const form = this.modalEl.querySelector('form');
                if (form) form.addEventListener('submit', this.handleSubmit.bind(this));
            } catch (error) {
                console.error(error);
            }
        });
    }

    async handleSubmit(event) {
        event.preventDefault();
        try {
            const { status, body } = await FetchHandler.sendFormData(event.target,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
            });
            if (status === 200 && body.success) {
                AlertHandler.showAlert(body.message, 'success');
                if (typeof window.reloadActivitiesList === 'function') {
                    window.reloadActivitiesList();
                } 
                if(body.note){
                    this.initDropzone(body.note);
                }
            } else {
                AlertHandler.showAlert(body.errors || 'Ein Fehler ist aufgetreten', 'danger');
            }
        } catch (error) {
            console.error('Caught error:', error);
            AlertHandler.showAlert('Ein Fehler ist aufgetreten: ' + error, 'danger');
        }
    }

    initDropzone(id) {

        const form = this.modalEl.querySelector('#activities_form');
        const dzArea = this.modalEl.querySelector('#activity-dropzone');
        const token = form.querySelector('[name="csrfmiddlewaretoken"]').value;
        
        dzArea.classList.remove('d-none');

        Dropzone.autoDiscover = false;
        this.dropzone = new Dropzone(dzArea, {
            url: `/activities/upload-attachment/${id}/`, 
            autoProcessQueue: true, 
            previewsContainer: dzArea,
            paramName: 'file', 
            headers: { 'X-CSRFToken': token },
            acceptedFiles: '.jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx',
            dictDefaultMessage: 'Bild hierher ziehen oder klicken',
        });

        this.dropzone.on('success', (file, res) => {
            console.log('Attachment gespeichert:', res.id);

            const successHint = document.createElement('span');
            successHint.textContent = '✔️ Bild erfolgreich gespeichert';
            successHint.classList.add('dz-success-hint');
            file.previewElement.appendChild(successHint);
            if (typeof window.reloadActivitiesList === 'function') {
                window.reloadActivitiesList();
            } 
        });

        this.dropzone.on('error', (file, errorMessage, xhr) => {
            const msg = (xhr && xhr.responseJSON && xhr.responseJSON.error) 
                ? xhr.responseJSON.error 
                : errorMessage;
            file.previewElement.querySelector('.dz-error-message').textContent = msg;
            console.error('Upload-Error:', msg);
        });
    }


}